import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Subject} from "rxjs";
import {DisplayFilter} from "../filters.component";
import {FilterService} from "../filter.service";
import * as moment_ from 'moment';
import * as moment__ from 'moment-timezone';

const moment = moment__;
const momentMoment = moment_;

@Component({
  selector: 'copart-age-range-filter',
  templateUrl: './age-range-filter.component.html',
  styleUrls: ['./age-range-filter.component.css']
})
export class AgeRangeFilterComponent implements OnInit, OnDestroy {

  /**
   * Stores the start Value for the filter
   */
  startValue: number;

  /**
   * Stores the end value for the filter
   */
  endValue: number;

  /**
   * Data about the filter
   */
  @Input() filterData: any;

  /**
   * event listener to listen to clear events
   */
  @Input() clearFilter: Subject<DisplayFilter>;

  /**
   * subscription handler
   */
  private clearSubscription: any;
  /**
   * Identifies if the end value is valid or not
   */
  isEndInValid: boolean;
  /**
   * Identifies if the start value is valid or not
   */
  isStartInvalid: boolean;

  /**
   * Lower limit for value selection
   */
  @Input() minValue: number;

  @Input() translateObject;

  @Output() response = new EventEmitter();

  preferredTimeZone: any;

  /**
   * Identifies if the start value is greater than end value
   */
  invalidRange: boolean;

  constructor(private filterService: FilterService) {
    this.isEndInValid = false;
    this.isStartInvalid = false;
    this.invalidRange = false;
    this.minValue = 0;
  }

  ngOnInit() {
    this.preferredTimeZone = this.translateObject.preferredTimeZone;
    this.clearSubscription = this.clearFilter.subscribe((filter) => {
      this.clearCustomFilter(filter);
    });
  }

  /**
   * Updates the filter data of the main filter with the values of the custom number range filter.
   */
  search() {
    if (this.startValue || this.endValue) {
      /* add the data to filter only if its populated */
      let query = this.filterData.rangeQuery;
      if (query) {
        query = query.replace('#to', this.toUtc(this.startValue,true));
        query = query.replace('#from', this.toUtc(this.endValue,false));
        query = query.replace('to', 'TO'); // TODO:Will be removed once the server changes are done
      }
      const name = this.getValue(this.startValue) + ' - ' + this.getValue(this.endValue);
      // Remove the previously applied number range filter, if any and don't emit event
      // so no server call is made to fetch new data
      this.filterService.clearFilter(this.filterData, false);
      this.response.emit({filter : this.filterData, item: {code: query, name}});
    }
  }

  private toUtc(pastYears : number,isEnd) {

    // Please note: Datepicker returns date in local time. We do not need time zone information
    // and simply need to extract date and treat it as UTC, set time and then send back
    if (!pastYears) {
      return '*';
    }
    const dateString = moment().subtract(pastYears,"years").format('YYYY-MM-DD'); // extract date

    let time = {hour: 0, minute: 0, second: 0, millisecond: 0};
    // placing this in comments as i see no importance && this.filterData.filter.rangeQuery.indexOf('_ts_utc') != -1
    if (isEnd) {
      time = {hour: 23, minute: 59, second: 59, millisecond: 0};
    }
    return moment.utc(moment.tz(dateString, this.preferredTimeZone).set(time)).toISOString(false);
  }

  private getValue(value : number): string {
    if (value) {
      return  value.toString();
    }
    return '*';
  }

  /**
   * Clears the custom filter fields.
   *  filter : Identifies, if the request for clearing the filter field was made to which filter.
   * if the clear request was for all the filters this field will be undefined,
   * else if the clear request was targeted for a particular filter the value stored in this variable will
   * match the filter header.
   */
  clearCustomFilter(filter) {
    if (!filter || (this.filterData && filter.code === this.filterData.code)) {
      this.clearCurrentFilter();
    }
  }

  /**
   * Event which listens to change in the input fields
   *  isStartValue : identifies if this is the start value input
   *  event :
   **/
  validate(isStartValue,) {
    if (isStartValue) {
      // if value is empty, its valid
      this.isStartInvalid =  this.checkIfInvalid(this.startValue);
    } else {
      this.isEndInValid = this.checkIfInvalid(this.endValue);
    }
    this.checkRange();
  }


  /**
   * Checks if the value is valid
   *  {boolean}
   */
  checkIfInvalid(value) {
    // if parsed number is null then its invalid
    return value != null && value < this.minValue;
  }

  /**
   * Checks if the values are in range or not
   */
  checkRange() {
    if (!this.startValue || !this.endValue) {
      this.invalidRange = false;
    } else {
      this.invalidRange =this.endValue < this.startValue;
    }
  }

  /**
   * Clears the search fields
   */
  private clearCurrentFilter() {
    this.startValue = null;
    this.endValue = null;
    this.isEndInValid = false;
    this.isStartInvalid = false;
    this.invalidRange = false;
  }


  /**
   * release all the resources and unsubscribe.
   */
  ngOnDestroy(): void {
    this.clearSubscription.unsubscribe();
  }
}
